import React, { useEffect, useRef, useState } from "react";
import { Heart } from "lucide-react";
import { useGuard } from "@/lib/guards";

// Lot 601 — double-tap sur le média d'une publication (photos, vidéos, albums) → cœur animé + réaction
// « J'adore », façon Instagram / Reels. Le simple tap (ouvrir la visionneuse, le théâtre…) est retardé de
// 280 ms pour laisser la place au 2e tap, puis rejoué tel quel ; les boutons de contrôle (son, plein écran,
// « +N ») ne sont pas concernés : seuls les taps posés sur une image ou une vidéo sont interceptés.
export const DOUBLE_TAP_MS = 280;

export const DoubleTapHeart = ({ onDoubleTap, testId, className = "", children }) => {
  const [burst, setBurst] = useState(false);
  const tap = useRef({ last: 0, timer: null, replay: false });
  const enabled = useGuard("double_tap_heart"); // lot 671 — garde-fou admin : coupé → le tap passe directement

  useEffect(() => () => clearTimeout(tap.current.timer), []);

  const onClickCapture = (e) => {
    if (!enabled) return;
    const s = tap.current;
    if (s.replay) { s.replay = false; return; }
    const target = e.target;
    if (!target?.closest?.("img, video")) return;
    const now = Date.now();
    e.preventDefault();
    e.stopPropagation();
    if (s.timer && now - s.last < DOUBLE_TAP_MS) {
      clearTimeout(s.timer);
      s.timer = null;
      s.last = 0;
      if (onDoubleTap?.() === false) return;
      setBurst(true);
      setTimeout(() => setBurst(false), 800);
      return;
    }
    s.last = now;
    clearTimeout(s.timer);
    s.timer = setTimeout(() => {
      s.timer = null;
      s.replay = true;
      try { target.click(); } finally { s.replay = false; }
    }, DOUBLE_TAP_MS);
  };

  return (
    <div className={`relative ${className}`} style={{ touchAction: "manipulation" }} onClickCapture={onClickCapture} data-testid={testId}>
      {children}
      {burst && (
        <div className="absolute inset-0 z-20 grid place-items-center pointer-events-none" data-testid={testId ? `${testId}-burst` : undefined}>
          <Heart size={110} fill="#E11D48" color="#E11D48" className="reel-heart-pop" style={{ filter: "drop-shadow(0 6px 18px rgba(0,0,0,0.45))" }} />
        </div>
      )}
    </div>
  );
};
